import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaGithub,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowUp,
  FaBuilding,
  FaFileInvoice,
} from "react-icons/fa";
import "./Footer.css";

// Match these paths to your application's routes.
const technologyServices = [
  ["Software Development", "/technology-digital-solutions"],
  ["Mobile App Development", "/technology-digital-solutions"],
  ["SEO Services", "/technology-digital-solutions"],
  ["UI/UX Design", "/technology-digital-solutions"],
  ["Technology Service Provider (TSP)", "/technology-digital-solutions"],
];

const paymentServices = [
  ["E-Governance Services", "/payments-e-governance"],
  ["Bill Payment Service", "/payments-e-governance"],
  ["Banking Business Correspondent Service", "/payments-e-governance"],
  ["Payment Services", "/payments-e-governance"],
];

const companyLinks = [
  ["About Us", "/about-us"],
  // ["Our Team", "/team"],
  // ["Careers", "/careers"],
  // ["Portfolio", "/portfolio"],
  ["Contact Us", "/contact-us"],
];

const legalLinks = [
  ["Privacy Policy", "/privacy-policy"],
  ["Terms and Conditions", "/terms-and-conditions"],
  ["Refund Policy", "/refund-policy"],
];

// Social URLs retained from your original component.
const socialLinks = [
  [FaFacebookF, "https://facebook.com/formaxitsolutions", "Facebook"],
  [FaTwitter, "https://x.com/formax_it", "Twitter"],
  [FaLinkedinIn, "linkedin.com/company/formax-pay", "LinkedIn"],
];

function FooterLinks({ title, links }) {
  return (
    <nav className="fit-footer__links" aria-label={`Footer: ${title}`}>
      <h2 className="fit-footer__heading">{title}</h2>

      <ul>
        {links.map(([label, href]) => (
          <li key={label}>
            <a href={href}>{label}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

const Footer = () => {
  const scrollToTop = () => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  };

  return (
    <footer className="fit-footer">
      <div className="fit-footer__container">
        {/* Brand and social links */}
        <div className="fit-footer__intro">
          <div className="fit-footer__identity">
            <a href="/" className="fit-footer__logo">
              <img
                src="/images/logo.png"
                alt="Formax IT Solutions — home"
                width="190"
                height="64"
                loading="lazy"
              />
            </a>

            <div className="fit-footer__brand-copy">
              <p className="fit-footer__company-name">
                Formax IT Solutions Pvt. Ltd.
              </p>
              <p className="fit-footer__tagline">
                Technology. Connectivity. Possibilities.
              </p>
            </div>
          </div>

          <div className="fit-footer__social-group">
            <span className="fit-footer__social-label">Connect with us</span>

            <div className="fit-footer__socials">
              {socialLinks.map(([Icon, href, label]) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${label} — opens in a new tab`}
                >
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Main footer columns */}
        <div className="fit-footer__main">
          <section
            className="fit-footer__about"
            aria-labelledby="fit-footer-about-title"
          >
            <h2 id="fit-footer-about-title" className="fit-footer__heading">
              Built around your business
            </h2>

            <p className="fit-footer__description">
              We bring software, digital services, and payment technology
              together to help businesses simplify operations and deliver better
              customer experiences.
            </p>

            <div
              className="fit-footer__registration"
              aria-label="Company registration details"
            >
              <div className="fit-footer__registration-card">
                <span className="fit-footer__registration-icon">
                  <FaBuilding aria-hidden="true" />
                </span>

                <div>
                  <span className="fit-footer__registration-type">CIN</span>
                  <strong>U72900WB2018PTC228240</strong>
                </div>
              </div>

              <div className="fit-footer__registration-card">
                <span className="fit-footer__registration-icon">
                  <FaFileInvoice aria-hidden="true" />
                </span>

                <div>
                  <span className="fit-footer__registration-type">GSTIN</span>
                  <strong>19AADCF5125F1ZT</strong>
                </div>
              </div>
            </div>
          </section>

          <FooterLinks
            title="Technology & Digital Solutions"
            links={technologyServices}
          />

          <FooterLinks
            title="Payments & E-Governance"
            links={paymentServices}
          />

          <FooterLinks title="Company" links={companyLinks} />

          <section
            className="fit-footer__contact"
            aria-labelledby="fit-footer-contact-title"
          >
            <h2 id="fit-footer-contact-title" className="fit-footer__heading">
              Get in touch
            </h2>

            <address>
              <div className="fit-footer__contact-item">
                <span className="fit-footer__contact-icon">
                  <FaMapMarkerAlt aria-hidden="true" />
                </span>

                <div>
                  <span className="fit-footer__contact-label">Our office</span>
                  <p>
                    Ground Floor, 16, Mochpole, Near Junior School, Nabapally,
                    Barasat, Kolkata – 700126, West Bengal, India
                  </p>
                </div>
              </div>

              <div className="fit-footer__contact-item">
                <span className="fit-footer__contact-icon">
                  <FaPhoneAlt aria-hidden="true" />
                </span>

                <div>
                  <span className="fit-footer__contact-label">Call us</span>
                  <a href="tel:+919836114520">+91 98361 14520</a>
                </div>
              </div>

              <div className="fit-footer__contact-item">
                <span className="fit-footer__contact-icon">
                  <FaEnvelope aria-hidden="true" />
                </span>

                <div>
                  <span className="fit-footer__contact-label">Email us</span>
                  <a href="mailto:info@formaxit.com">info@formaxit.com</a>
                </div>
              </div>
            </address>
          </section>
        </div>

        {/* Copyright and policies */}
        <div className="fit-footer__bottom">
          <p>
            © 2018 - {new Date().getFullYear()} Formax IT Solutions Pvt. Ltd.
            <span> All rights reserved.</span>
          </p>

          <nav className="fit-footer__legal" aria-label="Legal information">
            {legalLinks.map(([label, href]) => (
              <a key={label} href={href}>
                {label}
              </a>
            ))}
          </nav>

          <button
            type="button"
            className="fit-footer__back-top"
            onClick={scrollToTop}
            aria-label="Back to top"
          >
            <FaArrowUp aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
